import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState(null);
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setError("Missing session_id");
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/session-exchange", { session_id: sessionId });
        setUser(res.data);
        // Clean hash then navigate
        window.history.replaceState({}, "", "/");
        navigate("/", { replace: true, state: { user: res.data } });
      } catch (e) {
        const msg = e?.response?.data?.detail || e.message || "Login failed";
        setError(msg);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F7F5] p-6" data-testid="auth-callback-error">
        <div className="bg-white border border-gray-200 p-8 max-w-md rounded-sm">
          <h1 className="font-heading text-2xl mb-2">Sign-in failed</h1>
          <p className="text-sm text-gray-600 mb-6">{error}</p>
          <button
            onClick={() => (window.location.href = "/login")}
            data-testid="auth-error-back-to-login"
            className="bg-[#1B4332] text-white text-sm px-4 py-2 rounded-sm hover:bg-[#2D5A47] transition-colors duration-200"
          >Back to sign in</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F7F5]" data-testid="auth-callback-loading">
      <Loader2 className="h-6 w-6 animate-spin text-[#1B4332]" />
    </div>
  );
}
